/* eslint-disable */

import * as ApolloReactComponents from '@apollo/client/react/components';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CompletedWorkItemsQueryVariables = Types.Exact<{
    input: Types.YourWorkItemsInput;
}>;

export type CompletedWorkItemsQuery = {
    __typename: 'Query';
    yourWorkItems: { __typename: 'YourWorkItemsResult'; completedCount: number };
};

export const CompletedWorkItemsDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'CompletedWorkItems' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'YourWorkItemsInput' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'yourWorkItems' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'completedCount' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export type CompletedWorkItemsComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        CompletedWorkItemsQuery,
        CompletedWorkItemsQueryVariables
    >,
    'query'
> &
    ({ variables: CompletedWorkItemsQueryVariables; skip?: boolean } | { skip: boolean });

export const CompletedWorkItemsComponent = (props: CompletedWorkItemsComponentProps) => (
    <ApolloReactComponents.Query<CompletedWorkItemsQuery, CompletedWorkItemsQueryVariables>
        query={CompletedWorkItemsDocument}
        {...props}
    />
);

/**
 * __useCompletedWorkItemsQuery__
 *
 * To run a query within a React component, call `useCompletedWorkItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompletedWorkItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompletedWorkItemsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompletedWorkItemsQuery(
    baseOptions: Apollo.QueryHookOptions<CompletedWorkItemsQuery, CompletedWorkItemsQueryVariables>
) {
    return Apollo.useQuery<CompletedWorkItemsQuery, CompletedWorkItemsQueryVariables>(
        CompletedWorkItemsDocument,
        baseOptions
    );
}
export function useCompletedWorkItemsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        CompletedWorkItemsQuery,
        CompletedWorkItemsQueryVariables
    >
) {
    return Apollo.useLazyQuery<CompletedWorkItemsQuery, CompletedWorkItemsQueryVariables>(
        CompletedWorkItemsDocument,
        baseOptions
    );
}
export type CompletedWorkItemsQueryHookResult = ReturnType<typeof useCompletedWorkItemsQuery>;
export type CompletedWorkItemsLazyQueryHookResult = ReturnType<
    typeof useCompletedWorkItemsLazyQuery
>;
export type CompletedWorkItemsQueryResult = Apollo.QueryResult<
    CompletedWorkItemsQuery,
    CompletedWorkItemsQueryVariables
>;
